import React, { useEffect, useState } from 'react';

import Helmet from 'react-helmet';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { getQueryParams } from 'utils';
import { authModel } from 'models';
import { AUTH_HEADERS } from 'models/constants';
import { ROUTES } from 'routes/constants';
import { AccountCard, ButtonComponent } from 'components';
import { COLORS } from 'theme/constants';
import { SocialAccount } from 'types';
import { Box, BuilderAuthCard, BuilderTitle } from 'pages/auth/style';
import { redirectToSignIn } from 'utils/helpers/urlHelpers';

import { BuilderContactUsFooter } from '../BuilderContactUsFooter';

const BuilderSelectAccountPage = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [accounts, setAccounts] = useState<SocialAccount[]>([]);
  const [preAuthToken, setPreAuthToken] = useState('');

  useEffect(() => {
    const preAuthToken = getQueryParams().pre_auth_token;

    if (preAuthToken && typeof preAuthToken === 'string') {
      setPreAuthToken(preAuthToken);
      authModel.listAccounts({ token: preAuthToken }).then(response => {
        if (response.pubtoolToken) {
          localStorage.setItem(AUTH_HEADERS.PUBTOOL_TOKEN, response.pubtoolToken);
          history.push(ROUTES.home);
        } else if (response.accounts.length === 0)
          history.push({
            pathname: ROUTES.authGoogleAccountNotFound,
            search: `?pre_auth_token=${preAuthToken}`,
          });
        else setAccounts(response.accounts);
      });
    } else redirectToSignIn();
  }, []);

  const onSelectAccount = (account: any) => {
    authModel
      .socialSignIn({
        id: account.id,
        token: preAuthToken,
      })
      .then(response => {
        if (response.pubtoolToken) {
          localStorage.setItem(AUTH_HEADERS.PUBTOOL_TOKEN, response.pubtoolToken);
          history.push(ROUTES.home);
        }
      });
  };

  if (accounts.length === 0) return null;

  return (
    <BuilderAuthCard>
      <Helmet title={t('pages.auth.selectAccountPage.tabTitle')} />
      <Grid container direction="column" alignItems="center">
        <Grid item xl={7} style={{ flex: 1 }}>
          <Box mb={6}>
            <ButtonComponent
              color="primary"
              variant="text"
              className="no-padding"
              text="< Back"
              onClick={redirectToSignIn}
              style={{ color: COLORS.builderBrandColor }}
            />
          </Box>
          <Box mb={8}>
            <BuilderTitle>Select your World</BuilderTitle>
          </Box>
        </Grid>
        <Grid item xl={7} container direction="column" style={{ flex: 1, maxHeight: '53vh' }}>
          <Box display="flex" flexDirection="column" style={{ overflowY: 'auto' }}>
            {accounts.map(account => (
              <Grid item key={account.client}>
                <AccountCard
                  className="builder"
                  title={account.client}
                  text={account.email}
                  onClick={() => onSelectAccount(account)}
                />
              </Grid>
            ))}
          </Box>
        </Grid>
      </Grid>
      <BuilderContactUsFooter />
    </BuilderAuthCard>
  );
};

export default BuilderSelectAccountPage;
